import { jsx as e, jsxs as s, Fragment as p } from "react/jsx-runtime";
import { useState as P, useRef as I, useEffect as te, Fragment as ie } from "react";
/* empty css              */
import { getLinkType as q } from "./utils/linkUtil.js";
import { RightContentEnum as g } from "./components/Navigation/src/Header/Header.types.js";
import { l as ee } from "./lodash-KjtlrIXE.mjs";
import { g as se } from "./utils-X2ED81Se.mjs";
import { Popover as ne } from "./components/Compounds/src/Popover/Popover.js";
import { i as K, R as re } from "./ResetTool-Xt8wU8l_.mjs";
import { getCWPEnvironmentForURL as de, APIENDPOINT as ue } from "./utils/common-utils.js";
import "./utils/layout-util.js";
const ce = (c) => {
  var F, D, E, M, V, W;
  const {
    onClick: z,
    links: A,
    menuItems: b,
    rightContentType: B,
    resetModal: J,
    handleOpen: y,
    rigProps: N,
    handDownloadPDF: f
  } = c, x = (a) => {
    a != null && a.disabled || z();
  }, [i, H] = P({
    current: [...b],
    previous: [],
    currentLinks: []
  });
  if (b.length) {
    const a = new Event("NavLoaded");
    document.dispatchEvent(a);
  }
  const r = I(null), l = I(null);
  te(() => {
    var m;
    const a = l.current;
    if (!a) return;
    const v = [
      'a[href]:not([tabindex="-1"]):not([disabled])',
      'button:not([tabindex="-1"]):not([disabled])',
      '[tabindex]:not([tabindex="-1"]):not([disabled])'
    ], h = () => a.querySelectorAll(v.join(","));
    function o(u) {
      if (u.key !== "Tab") return;
      const L = Array.from(h());
      if (L.length === 0) return;
      const w = L[0], S = L[L.length - 1];
      u.shiftKey ? document.activeElement === w && (u.preventDefault(), S.focus()) : document.activeElement === S && (u.preventDefault(), w.focus());
    }
    return a.addEventListener("keydown", o), (m = h()[0]) == null || m.focus(), () => {
      a.removeEventListener("keydown", o);
    };
  }, []);
  const d = () => B === g.impactAnalyzerAAG ? /* @__PURE__ */ e("div", { className: "u-bgColorLight u-sizeFill u-paddingVert32 u-paddingHoriz16 ", children: /* @__PURE__ */ e(
    "button",
    {
      className: "Button Button--secondary Button--block u-bgColorWhite",
      onClick: y,
      children: "Reset Tool"
    }
  ) }) : B === g.annualReport2025 ? null : B === g.impactAnalyzerAFG && !ee.isEmpty(J) ? /* @__PURE__ */ s("div", { className: "u-bgColorLight u-sizeFill u-paddingVert32 u-paddingHoriz16 ", children: [
    /* @__PURE__ */ e(
      "button",
      {
        className: "Button Button--primary Button--block u-marginVert8",
        onClick: f,
        children: "Download Our Advantage PDF"
      }
    ),
    /* @__PURE__ */ e(
      "button",
      {
        className: "Button Button--secondary Button--block u-bgColorWhite",
        onClick: y,
        children: "Reset Tool"
      }
    )
  ] }) : B === g.retirementIncome && (A != null && A.length) && !ee.isEmpty(N) ? /* @__PURE__ */ e("div", { className: "u-bgColorLight u-sizeFill", children: /* @__PURE__ */ s("ul", { className: "List List--selectable u-margin0 u-sm-paddingVert5gu u-sm-paddingHoriz3gu u-md-paddingVert5gu u-md-paddingHoriz3gu u-textCenter", children: [
    /* @__PURE__ */ e("li", { className: "List-item u-textSizeMsrm1 u-textColorActionBlue", children: /* @__PURE__ */ s(
      "button",
      {
        className: "Link u-linkClean u-flex u-sizeFull u-alignItemsCenter u-flexJustifyCenter",
        rel: "noopener noreferrer",
        "data-analytics": "Download page",
        onClick: N.printContent,
        children: [
          /* @__PURE__ */ e(
            "span",
            {
              className: "adel-material-symbols-18 u-posRelative u-textColorActionBlue",
              role: "img",
              "aria-hidden": "true",
              children: "draft"
            }
          ),
          /* @__PURE__ */ e("span", { className: "u-textColorActionBlue u-textSizeMsrm1 u-marginLeft6", children: "Download page" })
        ]
      }
    ) }, "download page"),
    /* @__PURE__ */ e("li", { className: "List-item u-textSizeMsrm1 u-textColorActionBlue", children: /* @__PURE__ */ s(
      "button",
      {
        className: "Link u-linkClean u-flex u-sizeFull u-alignItemsCenter u-flexJustifyCenter",
        rel: "noopener noreferrer",
        "data-analytics": "Download all",
        onClick: N.printAllContent,
        children: [
          /* @__PURE__ */ e(
            "span",
            {
              className: "adel-material-symbols-18 u-textColorActionBlue",
              role: "img",
              "aria-hidden": "true",
              children: "file_copy"
            }
          ),
          /* @__PURE__ */ e("span", { className: "u-textColorActionBlue u-textSizeMsrm1 u-marginLeft6", children: "Download all" })
        ]
      }
    ) }, "download all"),
    !N.setupPage && /* @__PURE__ */ e("li", { className: "List-item u-textSizeMsrm", children: /* @__PURE__ */ e(
      le,
      {
        handleToolReset: N.handleToolReset,
        startOverAriaLabel: "Start over",
        className: "u-sizeFull u-bgColorWhite"
      }
    ) }, "reset button")
  ] }) }) : /* @__PURE__ */ e("div", { className: "u-bgColorLight u-sizeFill", children: (A == null ? void 0 : A.length) && /* @__PURE__ */ e("ul", { className: "List List--selectable u-margin0 u-sm-paddingVert5gu u-sm-paddingHoriz3gu u-md-paddingVert5gu u-md-paddingHoriz3gu u-textCenter", children: A.map((a) => {
    const v = typeof a.classes == "string" ? [a.classes] : a.classes, h = v ? v.reduce((o, C) => `${o} ${C}`, "") : "";
    return /* @__PURE__ */ e("li", { className: "List-item u-textSizeMsrm1 u-textColorActionBlue", children: a.type === "phone" ? /* @__PURE__ */ s(
      "a",
      {
        href: a.href ? `tel:${a.href}` : "#",
        "aria-label": a.text,
        target: a.target,
        className: `${q(a.type)} ${h} u-linkClean`,
        "data-analytics": a.analytics,
        children: [
          /* @__PURE__ */ s("i", { children: [
            /* @__PURE__ */ e(
              "span",
              {
                "aria-hidden": "true",
                className: "Icon u-textInheritColor u-textSizeMsrp1 u-alignMiddle u-marginRight4",
                children: ""
              }
            ),
            /* @__PURE__ */ e("span", { className: "u-hiddenVisually", children: "Phone number" })
          ] }),
          a.text
        ]
      },
      a.text
    ) : /* @__PURE__ */ e(
      "a",
      {
        href: a.href,
        "data-analytics": a.analytics,
        className: `Link ${a.type ? q(a.type) : ""} u-linkClean u-sizeFull u-flexJustifyCenter`,
        children: a.text
      }
    ) }, a.text);
  }) }) });
  return /* @__PURE__ */ e("div", { id: "mobileNav", className: "amp-mobile-nav u-lg-hidden", ref: l, children: /* @__PURE__ */ e("div", { className: "amp-nav amp-nav--fullHeight u-posRelative", children: /* @__PURE__ */ e("div", { className: "u-sizeConstrained amp-nav-inner u-flex Popover amp-nav-level-one is-visible u-marginTop0", children: /* @__PURE__ */ s("nav", { className: "u-flex u-flexCol u-flexAlignItemsStretch amp-nav-level-one u-sizeFull u-posRelative", children: [
    /* @__PURE__ */ s("ul", { className: "List List--selectable List--inline amp-mainNav u-flex u-flexCol u-flexJustifyStart u-borderBottom0", children: [
      i.previous.length ? /* @__PURE__ */ s(p, { children: [
        /* @__PURE__ */ e(
          "li",
          {
            className: "List-item amp-mainNav-item u-borderVert u-borderColorNeutral u-borderTop0 u-lg-hidden u-padding0 u-posRelative",
            onClick: () => {
              var o;
              const a = [...i.previous], v = [...a[a.length - 1]], h = [...i.currentLinks];
              h.pop(), a.pop(), H({
                ...i,
                current: [...v],
                previous: [...a],
                currentLinks: [...h]
              }), (o = r == null ? void 0 : r.current) == null || o.focus();
            },
            children: /* @__PURE__ */ s(
              "button",
              {
                ref: r,
                "data-icon": "",
                "data-analytics": "back button",
                className: "Link u-linkClean u-flex u-flexAlignItemsEnd u-sizeFull u-paddingVert16 u-paddingLeft8 u-paddingRight20",
                children: [
                  /* @__PURE__ */ e(
                    "span",
                    {
                      className: "adel-material-symbols-18 u-textColorInherit",
                      role: "img",
                      "aria-label": "Chevron Left",
                      children: "chevron_left"
                    }
                  ),
                  /* @__PURE__ */ e("span", { className: "u-marginLeft4 u-textSizeMsrm1", children: "Back" })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          "li",
          {
            className: "List-item amp-mainNav-item u-borderVert u-borderColorNeutral u-borderTop0 u-lg-hidden u-padding0 u-bgColorLight",
            onClick: () => {
              var a;
              return x(
                i == null ? void 0 : i.currentLinks[((a = i == null ? void 0 : i.currentLinks) == null ? void 0 : a.length) - 1]
              );
            },
            children: /* @__PURE__ */ e(
              "a",
              {
                className: "amp-mainNav-link u-textSizeMsrm1 u-textNoWrap u-posRelative u-paddingVert16 u-paddingHoriz20 u-textColorDefault",
                rel: "noopener noreferrer",
                href: ((D = i == null ? void 0 : i.currentLinks[((F = i == null ? void 0 : i.currentLinks) == null ? void 0 : F.length) - 1]) == null ? void 0 : D.url) || "",
                "data-analytics": ((M = i == null ? void 0 : i.currentLinks[((E = i == null ? void 0 : i.currentLinks) == null ? void 0 : E.length) - 1]) == null ? void 0 : M.name) || "",
                children: /* @__PURE__ */ e("span", { children: (W = i == null ? void 0 : i.currentLinks[((V = i == null ? void 0 : i.currentLinks) == null ? void 0 : V.length) - 1]) == null ? void 0 : W.name })
              }
            )
          }
        )
      ] }) : null,
      i.current.map((a, v) => {
        var S, G, j, _;
        const h = !((G = (S = a == null ? void 0 : a.HstMenuItemRepresentation) == null ? void 0 : S.parameters) != null && G.showDropdown && ((_ = (j = a == null ? void 0 : a.HstMenuItemRepresentation) == null ? void 0 : j.parameters) == null ? void 0 : _.showDropdown) === "false"), {
          HstMenuItemRepresentation: { name: o, url: C, menuItems: m = [], disabled: u }
        } = a, L = `List-item amp-mainNav-item${v === i.current.length - 1 ? "" : " u-borderVert u-borderColorNeutral u-borderTop0"} u-lg-hidden u-padding0 ${u && "u-disabled"}`, w = `u-paddingVert16 ${i.previous.length ? "u-paddingHoriz16 u-paddingLeft40" : "u-paddingHoriz16 u-paddingLeft20"}`;
        return /* @__PURE__ */ e(
          "li",
          {
            className: L,
            onClick: () => {
              var k;
              if (!u)
                if (m.length && h) {
                  const O = [...i.previous];
                  O.push([...i.current]);
                  const n = {
                    name: o,
                    url: C,
                    disabled: u
                  }, t = [...i.currentLinks];
                  t.push({ ...n }), H({
                    ...i,
                    current: [...m],
                    previous: [...O],
                    currentLinks: [...t]
                  }), (k = r == null ? void 0 : r.current) == null || k.focus();
                } else
                  z();
            },
            children: m.length && h ? /* @__PURE__ */ e(
              "button",
              {
                "data-analytics": o,
                className: `Link Link--trigger u-linkClean u-textSizeMsrm1 u-flex u-flexJustifyBetween u-flexAlignItemsEnd u-sizeFull ${w} ${u ? "u-disabled" : ""}`,
                children: o
              }
            ) : /* @__PURE__ */ e(
              "a",
              {
                className: `amp-mainNav-link u-textSizeMsrm1 u-textNoWrap u-posRelative ${w} ${u ? "u-disabled" : ""}`,
                rel: "noopener noreferrer",
                href: m.length && h ? void 0 : C,
                "data-analytics": o,
                onClick: (k) => {
                  u && (k.preventDefault(), k.stopPropagation());
                },
                children: o
              }
            )
          },
          o
        );
      })
    ] }),
    d()
  ] }) }) }) });
}, oe = de(window.location.href), ae = (c) => /* @__PURE__ */ s(
  "button",
  {
    "data-analytics": "RIG-save-PDF",
    onClick: c.togglePrintModalVisible,
    disabled: c.disable,
    "data-tracking": "Button",
    "aria-label": (c == null ? void 0 : c.ariaLabel) || c.label,
    className: "Button btn icon u-border0 full u-textColorActionBlue u-textSizeMsrm1 u-textMedium",
    children: [
      /* @__PURE__ */ e(
        "span",
        {
          className: "adel-material-symbols-18 u-textColorActionBlue u-marginRight8",
          role: "img",
          "aria-hidden": "true",
          children: c.label === "Download page" ? "draft" : "file_copy"
        }
      ),
      c.label,
      c.disable && /* @__PURE__ */ s("div", { className: "Loading Loading--small", children: [
        /* @__PURE__ */ e("div", { className: "Loading-indicator" }),
        /* @__PURE__ */ e("div", { className: "Loading-indicator" }),
        /* @__PURE__ */ e("div", { className: "Loading-indicator" }),
        /* @__PURE__ */ e("div", { className: "Loading-indicator" })
      ] })
    ]
  }
), le = (c) => /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
  "button",
  {
    onClick: c.handleToolReset,
    className: `u-marginRight16 u-md-marginRight0 u-sm-marginRight0 Button Button--secondary Button--secondary--action-blue ${c.className ? c.className : ""}`,
    "data-analytics": "RIG-reset-tool",
    "aria-label": (c == null ? void 0 : c.startOverAriaLabel) || "Start over",
    children: /* @__PURE__ */ e("span", { className: "u-textSizeMsrm1", children: "Start over" })
  }
) }), $ = [
  {
    text: "Online security guarantee",
    href: "/privacy-security-fraud/online-security-guarantee",
    analytics: "OnlineSecurityURL"
  },
  {
    text: "Customer service",
    href: "/customer-service",
    analytics: "CustomerServiceUrl"
  }
], Ae = ({
  headerDocument: c,
  mainMenu: z,
  backgroundColor: A,
  textColor: b,
  menuIconColor: B,
  layoutClass: J,
  dropdownOptions: y,
  mobileButton: N,
  rightContentType: f,
  resetModal: x,
  cleanLocalStorage: i,
  handDownloadPDF: H,
  rigProps: r,
  annualReportInfo: l,
  rpProps: d
}) => {
  var _, k, O;
  const [F, D] = P(!1), E = () => D(!0), M = () => D(!1), V = () => {
    D(!1), i && i();
  }, W = ((_ = window == null ? void 0 : window.AMPMSSITEPATH) == null ? void 0 : _.length) > 2 ? window.AMPMSSITEPATH + "images/shared/Ameriprise_Financial_logo.jpg" : void 0, [a, v] = P(!1), { desktopImage: h, siteName: o, siteNameHref: C, utilityNavigation: m } = c ?? {};
  let u, L = [];
  if ((k = z == null ? void 0 : z.data) != null && k.menuItems) {
    const { data: n } = z;
    L = n.menuItems, u = se(L);
  }
  const w = () => {
    const n = !a, t = document.querySelector("body");
    t && (n ? t.style.overflow = "hidden" : t.style.overflow = "auto"), v(n);
  };
  te(() => {
    const n = () => {
      window.innerWidth >= 1025 && a && w();
    };
    return window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, [a]);
  const S = (n) => /* @__PURE__ */ e(p, { children: n.map((t) => {
    const T = t.classes ? t.classes.reduce((R, U) => `${R} ${U}`, "") : "";
    return t.linkType === "phone" ? /* @__PURE__ */ s(
      "a",
      {
        href: t.linkHref ? `tel:${t.linkHref}` : "#",
        "aria-label": (t == null ? void 0 : t.linkAltText) || t.text,
        target: t.target,
        className: `${q(
          t.linkType
        )} ${T} u-linkClean u-md-hidden u-sm-hidden`,
        "data-analytics": t.analytics,
        children: [
          t.icon === "phone" && /* @__PURE__ */ s("i", { children: [
            /* @__PURE__ */ e(
              "span",
              {
                "aria-hidden": "true",
                className: "Icon u-textInheritColor u-textSizeMsrp1 u-alignMiddle u-marginRight4",
                children: ""
              }
            ),
            /* @__PURE__ */ e("span", { className: "u-hiddenVisually", children: "Phone number" })
          ] }),
          t.text
        ]
      },
      t.text
    ) : /* @__PURE__ */ s(
      "a",
      {
        href: t.linkHref,
        "aria-label": (t == null ? void 0 : t.linkAltText) || t.text,
        target: t.target,
        className: `${q(
          t.linkType
        )} ${T} u-linkClean u-md-hidden u-sm-hidden`,
        "data-analytics": t.analytics,
        children: [
          t.icon === "secure" && /* @__PURE__ */ e("i", { className: "Icon icon-shield u-marginRight4", "aria-hidden": "true" }),
          t.text
        ]
      },
      t.text
    );
  }) }), G = () => {
    var n, t, T, R, U, Y, Q, X, Z;
    return c && (m != null && m.length) ? S(m) : y ? /* @__PURE__ */ e(
      ne,
      {
        items: y.items,
        currentDisplayIndex: y.currentDisplayIndex,
        hiddenMessage: y.hiddenMessage
      }
    ) : f === g.impactAnalyzerAFG ? /* @__PURE__ */ s(p, { children: [
      /* @__PURE__ */ e(
        "button",
        {
          className: "Button Button--primary u-marginLeft12",
          onClick: H,
          "aria-label": "Download Our Advantage PDF",
          children: "Download Our Advantage PDF"
        }
      ),
      /* @__PURE__ */ e(
        "button",
        {
          className: "Button Button--secondary Button--secondary--action-blue",
          onClick: E,
          "data-analytics": "Reset Tool",
          "aria-label": (x == null ? void 0 : x.resetToolAriaLabel) || "Reset Tool",
          children: "Reset Tool"
        }
      )
    ] }) : f === g.impactAnalyzerAAG ? /* @__PURE__ */ e(
      "button",
      {
        className: "Button Button--secondary Button--secondary--action-blue",
        onClick: E,
        "data-analytics": "Reset Tool",
        "aria-label": (x == null ? void 0 : x.resetToolAriaLabel) || "Reset Tool",
        children: "Reset Tool"
      }
    ) : f === g.annualReport2025 ? /* @__PURE__ */ s("div", { className: "u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-paddingLeft20 u-sm-paddingLeft0", children: [
      /* @__PURE__ */ e(
        "a",
        {
          href: `mailto:?subject=${l == null ? void 0 : l.mailSubject}&body=${l == null ? void 0 : l.mailBody}`,
          "aria-label": `Share ${l == null ? void 0 : l.year} Annual Report via email`,
          className: "adel-material-symbols-24 u-textColorActionBlue u-marginRight8",
          children: "mail"
        }
      ),
      /* @__PURE__ */ s(
        "a",
        {
          href: l == null ? void 0 : l.pdfFilePath,
          "aria-label": `Download ${l == null ? void 0 : l.year} Annual Report as PDF`,
          className: "adel-material-symbols-24 u-textColorActionBlue u-marginRight24",
          rel: "external",
          target: "_blank",
          children: [
            "download",
            " "
          ]
        }
      ),
      /* @__PURE__ */ s("div", { className: "annualHeader-20YearImage u-flex", children: [
        /* @__PURE__ */ e(
          "img",
          {
            src: ue(oe).baseGallery + (l == null ? void 0 : l.yearsImage),
            alt: l == null ? void 0 : l.yearsImageAltText
          }
        ),
        (l == null ? void 0 : l.yearsImageTitle) && /* @__PURE__ */ e("span", { className: "annualHeader-20YearImageToolTip", children: l == null ? void 0 : l.yearsImageTitle })
      ] })
    ] }) : f === g.retirementIncome ? !K(r) && /* @__PURE__ */ s(p, { children: [
      !r.setupPage && !r.welcomePage && /* @__PURE__ */ s("div", { className: "u-flex u-flexRow u-flexAlignItemsCenter u-textSizeMsrm1", children: [
        /* @__PURE__ */ e(
          ae,
          {
            togglePrintModalVisible: r.printContent,
            label: "Download page",
            disable: r.singlePagePrinting,
            ariaLabel: ((n = r == null ? void 0 : r.buttons) == null ? void 0 : n.downloadPageAriaLabel) || ""
          }
        ),
        /* @__PURE__ */ e("div", { className: "u-borderLeft u-margin4 separator" }),
        /* @__PURE__ */ e(
          ae,
          {
            togglePrintModalVisible: r.printAllContent,
            label: "Download all",
            disable: r.allPagesPrinting,
            ariaLabel: ((t = r == null ? void 0 : r.buttons) == null ? void 0 : t.downloadAllAriaLabel) || ""
          }
        )
      ] }),
      !r.setupPage && /* @__PURE__ */ e(
        le,
        {
          handleToolReset: r.handleToolReset,
          startOverAriaLabel: (T = r == null ? void 0 : r.buttons) == null ? void 0 : T.startOverAriaLabel
        }
      )
    ] }) : f === g.retirementProfile ? !K(d) && /* @__PURE__ */ e("div", { className: "u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-paddingLeft20 u-sm-paddingLeft0", children: /* @__PURE__ */ s("div", { className: "PageHeader-buttonWrap u-sm-hidden u-md-flexRow u-lg-flexRow u-sm-marginTop20", children: [
      d.flowType === "aac" ? /* @__PURE__ */ e(
        "button",
        {
          "data-analytics": "RDE-share-your-results-btn",
          "aria-label": "Request an appointment with an Ameriprise advisor",
          onClick: () => d.setShowModal("aac"),
          className: "Button Button--secondary Button--secondary--action-blue Button--small",
          children: (R = d.buttons) == null ? void 0 : R.appointmentText
        }
      ) : /* @__PURE__ */ e(p, { children: !d.hasAdvisor && d.flowType !== "crm" && /* @__PURE__ */ e(
        "a",
        {
          href: "https://www.ameripriseadvisors.com/",
          target: "_blank",
          rel: "noopener noreferrer",
          "data-analytics": "RDE-top-nav-find-an-advisor-btn",
          className: "Button Button--secondary Button--secondary--action-blue Button--small",
          children: (U = d.buttons) == null ? void 0 : U.findAdvisorText
        }
      ) }),
      d.results && /* @__PURE__ */ s(p, { children: [
        d.flowType === "crm" && /* @__PURE__ */ s(p, { children: [
          d.shareResultsFailure && /* @__PURE__ */ e("div", { className: "advisor__error", children: "Something went wrong while sharing your results. Please try resharing or try again later" }),
          /* @__PURE__ */ e(
            "button",
            {
              "data-analytics": "RDE-share-your-results-btn",
              "aria-label": "Download your results PDF",
              onClick: d.shareResultsWithAdvisor,
              className: "Button Button--secondary Button--secondary--action-blue Button--small",
              disabled: d.resultsShared,
              children: d.resultsShared ? (Y = d.buttons) == null ? void 0 : Y.sharedText : (Q = d.buttons) == null ? void 0 : Q.shareText
            }
          )
        ] }),
        d.flowType !== "crm" && d.hasAdvisor && /* @__PURE__ */ e(
          "button",
          {
            className: "Button Button--secondary Button--secondary--action-blue Button--small",
            "data-analytics": "RDE-share-your-results-btn",
            "aria-label": "Share your results with your advisor",
            onClick: () => d.setShowModal(
              `${d.flowType === "referred" ? "referred" : "nonCrm"}`
            ),
            children: (X = d.buttons) == null ? void 0 : X.shareText
          }
        ),
        /* @__PURE__ */ e("div", { className: "rdeamp-header_retake", children: /* @__PURE__ */ s(
          "button",
          {
            "data-analytics": "RDE-restart-quiz-with-arrow-btn",
            className: "btn",
            "aria-label": "Restart the quiz",
            onClick: d.resetExperience,
            children: [
              /* @__PURE__ */ e("span", { className: "adel-material-symbols-18", "aria-hidden": "true", children: "replay" }),
              (Z = d.buttons) == null ? void 0 : Z.restartText
            ]
          }
        ) })
      ] })
    ] }) }) : m != null && m.length ? null : /* @__PURE__ */ s(p, { children: [
      /* @__PURE__ */ s(
        "a",
        {
          href: $[0].href,
          "data-analytics": $[0].analytics,
          className: "Link u-linkClean u-flex u-flexAlignItemsCenter",
          children: [
            /* @__PURE__ */ e("span", { className: "adel-material-symbols-16 u-marginRight4", "aria-hidden": "true", role: "img", children: "security" }),
            $[0].text
          ]
        }
      ),
      /* @__PURE__ */ e("div", { className: "pipe--Divider u-posRelative" }),
      /* @__PURE__ */ e(
        "a",
        {
          href: $[1].href,
          "data-analytics": $[1].analytics,
          className: "Link u-linkClean",
          children: $[1].text
        }
      )
    ] });
  }, j = () => {
    let n = [];
    return o && C && n.push({
      text: o,
      href: C
    }), m != null && m.length && (n = [
      ...n,
      ...m.map(
        (t) => ({
          text: t.text,
          href: t.linkHref,
          target: t.target,
          type: t.linkType,
          classes: t.classes
        })
      )
    ]), y && (n = [
      ...n,
      ...y.items.filter((t, T) => T !== Number(y.currentDisplayIndex)).map(
        (t) => ({
          text: `${t.text} Careers`,
          href: t.href,
          target: t.target
        })
      )
    ]), N && n.push({
      text: N.text,
      href: N.href,
      analytics: N.analytics,
      type: "default",
      target: "_blank"
    }), n.length > 0 ? n : $;
  };
  return /* @__PURE__ */ s(p, { children: [
    /* @__PURE__ */ e(
      "header",
      {
        id: "StandardHeader",
        className: `${J ? "u-paddingRight16 u-sm-paddingLeft16 u-md-paddingLeft16" : ""} u-paddingVert16 ${A} ${b}`,
        children: /* @__PURE__ */ e("div", { className: J || "u-sizeConstrained", children: /* @__PURE__ */ s("div", { className: "amp-header-mobile-icon u-flex u-flexRow u-flexJustifyBetween u-flexAlignItemsCenter", children: [
          /* @__PURE__ */ e(
            "button",
            {
              className: "u-lg-hidden amp-hamburger u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-overflowHidden",
              onClick: w,
              "data-testid": "popover-button",
              "aria-expanded": a,
              children: a ? /* @__PURE__ */ s("i", { children: [
                /* @__PURE__ */ e("span", { "aria-hidden": "true", className: `Icon u-textSizeMsrp4 ${b}`, children: "" }),
                /* @__PURE__ */ e("span", { className: `u-hiddenVisually ${b}`, children: "Close Menu" })
              ] }) : /* @__PURE__ */ s("div", { className: "u-flex u-flexCol u-flexJustifyCenter u-flexAlignItemsCenter u-sizeFull", children: [
                /* @__PURE__ */ s("div", { className: "amp-hamburger-icon", children: [
                  /* @__PURE__ */ s("div", { "aria-hidden": "true", className: `${b}`, children: [
                    /* @__PURE__ */ e(
                      "div",
                      {
                        className: `amp-hamburger-icon-dash u-marginTop4 u-marginBottom4 ${B}`,
                        children: " "
                      }
                    ),
                    /* @__PURE__ */ e(
                      "div",
                      {
                        className: `amp-hamburger-icon-dash u-marginTop4 u-marginBottom4 ${B}`,
                        children: " "
                      }
                    ),
                    /* @__PURE__ */ e(
                      "div",
                      {
                        className: `amp-hamburger-icon-dash u-marginTop4 u-marginBottom4 ${B}`,
                        children: " "
                      }
                    )
                  ] }),
                  /* @__PURE__ */ e("span", { className: `u-hiddenVisually ${b}`, children: "MENU" })
                ] }),
                /* @__PURE__ */ e(
                  "div",
                  {
                    className: `amp-hamburger-label u-textSizeMsrm2 ${b}`,
                    "data-qa": "HamburgerMenu",
                    children: "MENU"
                  }
                )
              ] })
            }
          ),
          /* @__PURE__ */ e("a", { href: "/", className: "u-linkClean", children: /* @__PURE__ */ e("img", { className: "", alt: "ameriprise logo", src: h ?? W }) }),
          f === g.annualReport2025 && /* @__PURE__ */ s("div", { className: "u-flex u-flexRow u-md-flexCol u-sm-flexCol u-flexAlignItemsCenter", children: [
            /* @__PURE__ */ e(
              "p",
              {
                className: `annualreport-HeaderName u-textBold
                   u-lg-textSizeMsrp3 u-md-textSizeMsrm2 u-sm-textSizeMsrm2 u-marginRight4 u-textColorMidnightBlue`,
                children: "2025"
              }
            ),
            /* @__PURE__ */ e("p", { className: "annualreport-HeaderName u-lg-textSizeMsrp3 u-md-textSizeMsrm2 u-sm-textSizeMsrm2 u-textColorMidnightBlue", children: "Annual Report" }),
            /* @__PURE__ */ s("div", { className: "u-lg-hidden", children: [
              /* @__PURE__ */ e(
                "a",
                {
                  href: `mailto:?subject=${l == null ? void 0 : l.mailSubject}&body=${l == null ? void 0 : l.mailBody}`,
                  "aria-label": `Share ${l == null ? void 0 : l.year} Annual Report via email`,
                  className: "adel-material-symbols-24 u-textColorActionBlue u-marginRight8",
                  children: "mail"
                }
              ),
              /* @__PURE__ */ s(
                "a",
                {
                  href: l == null ? void 0 : l.pdfFilePath,
                  "aria-label": `Download ${l == null ? void 0 : l.year} Annual Report as PDF`,
                  className: "adel-material-symbols-24 u-textColorActionBlue u-marginRight24",
                  rel: "external",
                  target: "_blank",
                  children: [
                    "download",
                    " "
                  ]
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ s("div", { className: "header--Buttons u-flex u-flexRow u-flexJustifyBetween u-flexAlignItemsCenter u-textSizeMsrm1 u-sm-hidden u-md-hidden", children: [
            o && C && /* @__PURE__ */ e("div", { className: `u-marginHoriz16 ${b}`, children: /* @__PURE__ */ e(
              "a",
              {
                className: `u-linkClean ${b}`,
                href: C,
                "data-analytics": o,
                children: o
              }
            ) }),
            G()
          ] })
        ] }) })
      }
    ),
    (f === g.impactAnalyzerAAG || f === g.impactAnalyzerAFG) && !K(x) ? /* @__PURE__ */ e(
      re,
      {
        reset: x,
        isOpen: F,
        onClose: M,
        onSubmit: V
      }
    ) : null,
    u && ((O = u == null ? void 0 : u.currentPageParams) == null ? void 0 : O.breadcrumbDisable) !== "true" && (u == null ? void 0 : u.breadCrumbs.length) !== 0 && /* @__PURE__ */ e("nav", { className: "breadcrumbs u-lg-hidden u-md-paddingHoriz8 u-sm-paddingLeft16", children: /* @__PURE__ */ e("ul", { children: u.breadCrumbs.map((n) => /* @__PURE__ */ s(ie, { children: [
      /* @__PURE__ */ e(
        "span",
        {
          "aria-hidden": "true",
          className: "Icon u-textSizeMsrm1 List-item u-paddingVert8 u-paddingHoriz8",
          children: ""
        }
      ),
      /* @__PURE__ */ e("li", { className: "u-textSizeMsrm1 List-item u-paddingVert8 u-paddingHoriz0", children: /* @__PURE__ */ e(
        "a",
        {
          "data-testid": n.pageName,
          href: n.pageURL,
          className: `u-textSizeMsrm1 ${(u == null ? void 0 : u.currentPageParams.breadcrumbReverse) === "true" && "u-textColorWhite"}`,
          children: n.pageName
        }
      ) })
    ] }, n.pageName)) }) }),
    a && /* @__PURE__ */ e(
      ce,
      {
        menuItems: L,
        links: j(),
        onClick: w,
        resetModal: x,
        isOpen: F,
        onClose: M,
        onSubmit: V,
        rightContentType: f,
        handleOpen: E,
        rigProps: r,
        handDownloadPDF: H
      }
    )
  ] });
};
export {
  Ae as H,
  ce as M,
  le as R
};
//# sourceMappingURL=Header-iC4rYuem.mjs.map
